<script setup lang="ts">
import { AggregateBusinessFilterProperty, FilterType, ForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import BaseSelectInput from './BaseSelectInput.vue';
import { FilterInfoState } from './interface/uiState';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { ref, watch } from 'vue';
import { FilterModalType } from '../filterModal/filterModal';

const props = withDefaults(
  defineProps<{
    index: number;
    modelValue: string;
    placeholder: string;
    label: string;
    disabled?: boolean;
    filterType: FilterType;
    isOpenProp?: boolean;
    propAggregateBusinessFilterProperty?: AggregateBusinessFilterProperty;
    propCustomerForecastFilterProperty?: ForecastTimelineFilterProperty;
    // 以下は使用元で選択肢を指定してfetch処理を括り出す場合に使用
    propOptions?: string[];
    propPagingState?: FilterInfoState;
    propPagingOptions?: IPagingOptions;
    isError?: boolean;
    errorMessage?: string;
    useTeleport?: boolean;
    filterModalType?: FilterModalType;
  }>(),
  {
    propAggregateBusinessFilterProperty: undefined,
    propCustomerForecastFilterProperty: undefined,
    /**
     * propOption初期化 defaultでArray, Objectを指定する場合ファクトリー関数を用いる必要がある
     */
    propOptions: () => [] as string[],
    propPagingState: undefined,
    propPagingOptions: undefined,
    errorMessage: '',
    filterModalType: 'deletion-business',
  }
);

const emit = defineEmits<{
  (e: 'click:selectInput'): void;
  (e: 'update:modelValue', value: string): void;
  (e: 'update:valueWithIndex', value: string, index: number): void;
  (e: 'click:seeMore'): void;
  (e: 'close'): void;
}>();

const selectedRepresent = ref<string>(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    selectedRepresent.value = props.modelValue;
  }
);

/**
 * 選択されたオプションを親コンポーネントに通知します。
 * @param option - 選択されたオプション
 * @param index - 選択されたオプションのインデックス
 */
const selectOption = (option: string, index?: number) => {
  selectedRepresent.value = option;
  emit('update:modelValue', option);
  if (index != undefined) emit('update:valueWithIndex', option, index);
  emit('close');
};

/**
 * オプションをリセットします。
 */
const resetOption = () => {
  selectedRepresent.value = '';
  emit('update:modelValue', '');
  emit('close');
};
</script>
<template>
  <BaseSelectInput
    :index="index"
    :selected-represent="selectedRepresent"
    :placeholder="placeholder"
    :label="label"
    :disabled="disabled"
    :filter-type="filterType"
    :is-open-prop="isOpenProp"
    :prop-aggregate-business-filter-property="propAggregateBusinessFilterProperty"
    :prop-customer-forecast-filter-property="propCustomerForecastFilterProperty"
    :prop-options="propOptions"
    :prop-original-options="propOptions"
    :prop-paging-state="propPagingState"
    :prop-paging-options="propPagingOptions"
    :is-error="isError"
    :error-message="errorMessage"
    :use-teleport="useTeleport"
    @click:select-input="() => $emit('click:selectInput')"
    @reset="resetOption"
    @update="(e, index) => selectOption(e, index)"
    @click:see-more="() => $emit('click:seeMore')"
    @close="() => $emit('close')"
  />
</template>
<style scoped lang="scss"></style>
